import React from 'react';
import {SurveyProvider} from "../../context/SurveyContext";
import Survey from './Survey';
import { Trans, useLingui } from '@lingui/react/macro';
import usePreCruisePassengers from '../../hooks/usePreCruisePassengers';
import InfoBox from './InfoBox';

function CovidSurveyPage(props) {
    const { t } = useLingui();
    const passengers = usePreCruisePassengers();

    const SurveyInfoSection = () => (
        <>
            <div className="mt-4 leading-normal text-lg text-grey-darker">
                <Trans id="health_survey_guideline">
                    The health declaration is to be completed by the lead guest within 72 hours
                    prior to embarkation. You are making this Health Declaration on behalf of:{' '}
                </Trans>
                <b> {passengers ? passengers.map(p => `${p.firstName} ${p.lastName}`).join(", ") : "" } </b>
            </div>

            <InfoBox
                classes="mt-6 md:inline-block"
                infoText={t({ id: "health_survey_info_text" })}
            />
        </>
    );

    return (
        <SurveyProvider>
            <Survey
                title={t({id: "health_survey"})}
                preSurveySection={<SurveyInfoSection />}
                category="covidSurvey"
                reponseKeyName="covid"
            />
        </SurveyProvider>
    );
}


export default CovidSurveyPage;
